import { heatTier } from '@/utils/content';

interface HeatBadgeProps {
  heat: number;
  size?: 'sm' | 'md';
}

export default function HeatBadge({ heat, size = 'sm' }: HeatBadgeProps) {
  const tier = heatTier(heat);
  const pad = size === 'sm' ? 'px-2 py-0.5 text-[11px]' : 'px-2.5 py-1 text-xs';
  return (
    <span className={`inline-flex items-center gap-1 rounded-full font-semibold whitespace-nowrap ${pad} ${tier.className}`}>
      <span className="w-3.5 h-3.5 flex items-center justify-center">
        <i className="ri-fire-fill text-[11px]" />
      </span>
      {tier.label}
      <span className="opacity-80">{heat}</span>
    </span>
  );
}